import React, {useState} from 'react';
import {Button} from "primereact/button";
import {Password} from "primereact/password";
import {AccountService} from "../../service/AccountService";
import {getKeyValue} from "../../utils/Utils";
import {AppContext} from "../../HomePage";

const ChangePassword = (props) => {

    const {t, toast, setError} = React.useContext(AppContext);

    const accountService = new AccountService();

    const[old_password, set_old_password] = useState("");
    const[new_password, set_new_password] = useState("");
    const[password_again, set_password_again] = useState("");
    const[disabled, setDisabled] = useState(false);

    const save = () => {
        if (disabled) {
            return;
        }
        setDisabled(true);

        if (new_password !== password_again)
        {
            setDisabled(false);
            toast.current.show({severity: "error", summary: t('message_detail.error'), detail: t('validations.password_no_match')});
            return;
        }
        accountService.changeMyPassword(old_password, new_password).then(user_updated=>{
            toast.current.show({severity: 'success', summary: t('actions.change_password'), detail: t('message_detail.successful')});
            setDisabled(false);
        }).catch(error =>{
            setError(error);
            setError(null);
            setDisabled(false);
        });
    };

    return (
        <div className="acc-section acc-narrow p-fluid">
            <p className="acc-section-title">{t('actions.change_password', 'Change password')}</p>
            <p className="acc-section-sub">{t('account.password.sub', 'Use a strong password you do not reuse elsewhere.')}</p>
            <div className="acc-field">
                <label htmlFor="old_password">{t('user.old_password', 'Current password')}</label>
                <Password id="old_password" name="old_password" feedback={false} value={old_password} onChange={(e) => set_old_password(getKeyValue(e).value)} />
            </div>
            <div className="acc-field">
                <label htmlFor="new_password">{t('user.new_password', 'New password')}</label>
                <Password id="new_password" name="new_password" value={new_password} onChange={(e) => set_new_password(getKeyValue(e).value)} />
            </div>
            <div className="acc-field">
                <label htmlFor="password_again">{t('user.password_again', 'Confirm new password')}</label>
                <Password id="password_again" name="password_again" feedback={false} value={password_again} onChange={(e) => set_password_again(getKeyValue(e).value)} />
            </div>
            <Button label={t('actions.save', 'Save')} icon="pi pi-save" className="p-button-outlined p-button-success" onClick={save} disabled={disabled} />
        </div>
    );
};
export default ChangePassword;
